import { render } from "./shareChannelDetail.vue?vue&type=template&id=7d4a44c8&scoped=true"
import script from "./shareChannelDetail.vue?vue&type=script&lang=js"
export * from "./shareChannelDetail.vue?vue&type=script&lang=js"

import "./shareChannelDetail.vue?vue&type=style&index=0&id=7d4a44c8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d4a44c8"],['__file',"src/views/enterPriseConfig/components/shareChannelDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d4a44c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d4a44c8', __exports__)) {
    console.log('reload')
    api.reload('7d4a44c8', __exports__)
  }
  
  module.hot.accept("./shareChannelDetail.vue?vue&type=template&id=7d4a44c8&scoped=true", () => {
    console.log('re-render')
    api.rerender('7d4a44c8', render)
  })

}


export default __exports__